import declare from "dojo/_base/declare";
import { Field } from "csi/def/Field";
import ProductHierarchyForm from "./ProductHierarchyForm";
import CopyProductHierarchyLevelMixin from "./CopyProductHierarchyLevelMixin";

const SUBTYPE = "Subtype";

const CopyProductHierarchyForm = declare([ProductHierarchyForm, CopyProductHierarchyLevelMixin], {

	/**
	 * Disable Subtype field for copy
	 * @override
	 */
	_updateFieldVisibility(field: Field) {
		this.inherited(arguments);
		this.setFieldDisabled(SUBTYPE, true);
		return true;
	},
});

export = CopyProductHierarchyForm;